import {
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_FLAG,
  EDIT_PROFILE_RESET,
} from "./actionTypes"

const initialState = {
  error: null,
  success: null,
}

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state }
      break
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload }
      break
    case PROFILE_ERROR:
      state = { ...state, error: action.payload }
      break
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null }
      break
    case EDIT_PROFILE_RESET:
      state = { ...state, success: null, error: null }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
